import { ProductDimensionValue } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import { IBuyboxGetDimensionVariantAvailabilityActionData } from '../../../../data-actions/buybox-get-dimension-variants-availability-action';
import { getQueryParamsFromQueryByName } from '../../../../data-actions/utilities/utils';
import { variantQueryStringName } from '../../../../Utilities/constants';
export interface IListingProps {
    swatchName: string;
    dimension: IDimensionData;
    baseImageUrl: string;
    availabilityList: IBuyboxGetDimensionVariantAvailabilityActionData[];
    selectedSize: string;
    generateOnClick(id: number, value: string, variantID: number): (e: React.MouseEvent<HTMLElement>) => void;
    setActiveVariant(variantID: number): void;
    isVariantSelectionRedesignEnabled: boolean;
    selectedValueAvailable: boolean | undefined;
}
export interface IDimensionData {
    DimensionTypeValue: number;
    DimensionValue?: ProductDimensionValue;
    DimensionValues?: ProductDimensionValue[];
}
/**
 *
 * Listing component
 * @extends {React.PureComponent<IListingProps>}
 */

export const _renderSlashItem = (
    isVariantSelectionRedesignEnabled: boolean
): JSX.Element => {
    return (
        isVariantSelectionRedesignEnabled
            ? <i className='gg-format-slash-redesign' />
            : <i className='gg-format-slash' />
    );
};

const Listing = (props: IListingProps) => {
    const render = (props: IListingProps) => {
        const { baseImageUrl, dimension, generateOnClick, setActiveVariant, selectedValueAvailable, isVariantSelectionRedesignEnabled } = props;
        return (
            <ul className={`ms-buybox__list ${props.swatchName}-swatch`}>
                {dimension.DimensionValues
                    ? dimension.DimensionValues.map((dimensionValue, index) => {
                        const recordID = dimensionValue.RecordId.toString();
                        let isAvailable = false;
                        // For value of current color variant ID
                        let currVariantID = -1;
                        // check variant availability list to see if variant is out of stock
                        for (let i = 0; i < props.availabilityList.length; i++) {
                            const colorDimensionRecordId = JSON.stringify(props.availabilityList[i].colorDimensionRecordId);
                            if (props.selectedSize === props.availabilityList[i].sizeValue && colorDimensionRecordId === recordID) {
                                isAvailable = props.availabilityList[i].isAvailable;
                                currVariantID = props.availabilityList[i].variantID;
                            }
                        }
                        const dimensionId = dimensionValue.DimensionId?.replace(/[/]/g, '^')?.replace(/\s+/g, '_').toLowerCase();
                        const selectedValue = (dimension.DimensionValue && dimension.DimensionValue.RecordId) || 'not available';
                        const isActive = selectedValue === dimensionValue.RecordId;
                        const url = new URL(window.location.href.toString());
                        const isVariantIdNotAvailable = Number(getQueryParamsFromQueryByName(url, variantQueryStringName)) ? false : true;

                        if (isActive) {
                            if (isVariantIdNotAvailable || !selectedValueAvailable) {
                                const element = document.getElementsByClassName("selected")[0] as HTMLElement;
                                element?.click();
                            }
                            setActiveVariant(currVariantID);
                        }
                        return (
                            !isAvailable ?
                                <li
                                    key={index}
                                    className={'slash'}
                                >
                                    <div className='oos-color' style={{ backgroundImage: `url(${baseImageUrl.slice(0, -1)}${dimensionId}.jpg)` }}>
                                        {/*Note: will likely eventually update generateOnClick so you can pass in dimensionValue.RecordId instead of the index*/}
                                        <button>{dimensionValue.Value}</button>
                                        {_renderSlashItem(isVariantSelectionRedesignEnabled)}
                                    </div>
                                </li>
                                :
                                <li
                                    key={index}
                                    className={isActive ? 'selected' : ''}
                                    onClick={generateOnClick(dimension.DimensionTypeValue, recordID.toString(), currVariantID)}
                                    role='button'
                                >
                                    <div className={`${isActive && 'active-color'}`} style={{ backgroundImage: `url(${baseImageUrl.slice(0, -1)}${dimensionId}.jpg)` }}>
                                        {/*Note: will likely eventually update generateOnClick so you can pass in dimensionValue.RecordId instead of the index*/}
                                        <button>{dimensionValue.Value}</button>
                                    </div>
                                </li>
                        );
                    })
                    : false}
            </ul>
        );
    };
    return render(props);
};
export default Listing;